module.exports = "https://static.wanderu.com/ui-react/_next/static/media/chiku-newsletter.43def637.png";